// ── Platform base domain (frontend) - single source of truth ───────────────────
// Mirrors the backend BASE_DOMAIN. Set REACT_APP_BASE_DOMAIN at build time for a
// staging build on a different domain; DEFAULTS to "redu.cloud" so the normal
// production build is unchanged. (CRA inlines REACT_APP_* at build time.)
export const BASE_DOMAIN = process.env.REACT_APP_BASE_DOMAIN || "redu.cloud";

const ESC = BASE_DOMAIN.replace(/[.]/g, "\\.");
/** Auto-generated name like "myapp-a1b2c3d4.<BASE_DOMAIN>". */
export const autoGenDnsPattern = new RegExp(`^[a-z0-9-]+-[a-z0-9]{8}\\.${ESC}$`);
/** True when a domain is under the platform base domain (one of ours) vs a custom domain. */
export const isBaseDomain = (domain: string): boolean => domain.endsWith(`.${BASE_DOMAIN}`);
